
import { Component, ModelSync, Vue } from 'vue-property-decorator';

@Component
export default class EventFlowSwitch extends Vue {
    @ModelSync('eventFlowSelected', 'change', { type: Boolean })
    eventFlowSelectedValue!: boolean;
}
